import API from 'api/api'
import endpoints from 'api/endpoints/lambda'
import { toast } from 'react-toastify'
import { updateValueLocalStorage } from 'utils/storage'
import { IHandleLogin } from './props'

export const handleLogin = async ({
  setLoading,
  form,
  callback,
  twoFactorCallback,
}: IHandleLogin) => {
  try{
    setLoading(true)

    const { response } = await API.request({
      path: endpoints.login,
      method: 'POST',
      body: form
    })

    if(!response?.success) throw new Error(response?.error)

    if (response.data?.requiresTwoFactor) {
      twoFactorCallback?.(response.data)
      return
    }

    updateValueLocalStorage('token', response.data.accessToken.token)
    callback(response.data.accessToken.email)
  }catch(err: any) {
    toast.error(`${err.message || 'Usuario y/o Contraseña incorrecta'}`)
  }finally{
    setLoading(false)
  }
}

export const handleVerifyTwoFactor = async ({
  setLoading,
  email,
  code,
  callback,
}: {
  setLoading: Function,
  email: string,
  code: string,
  callback: Function,
}) => {
  try {
    setLoading(true)

    const { response } = await API.request({
      path: endpoints.loginVerifyTwoFactor,
      method: 'POST',
      body: { email, code },
    })

    if(!response?.success) throw new Error(response?.error)

    updateValueLocalStorage('token', response.data.accessToken.token)
    callback(response.data.accessToken.email)
  } catch (err: any) {
    toast.error(`${err.message || 'Código de verificación inválido o expirado'}`)
  } finally {
    setLoading(false)
  }
}
